// @flow
import * as React from 'react';

const { useEffect, useState, useCallback } = React;

type ScrollPosition = [number, number];

const ScrollContext = React.createContext<ScrollPosition>([0, 0]);

export default ScrollContext;

export const ScrollContextProvider = ({
  children
}: {
  children: React.Node
}) => {
  const [scroll, setScroll] = useState([0, 0]);

  const handleScroll = useCallback(
    () => {
      if (
        window.pageXOffset !== scroll[0] ||
        window.pageYOffset !== scroll[1]
      ) {
        setScroll([window.pageXOffset, window.pageYOffset]);
      }
    },
    [scroll]
  );

  useEffect(
    () => {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    },
    [handleScroll]
  );
  return (
    <ScrollContext.Provider value={scroll}>{children}</ScrollContext.Provider>
  );
};
